import { connectScopedPaymentCardOption } from '../common';
import { PaymentCardOption as PaymentCardOptionPure } from './PaymentCardOption';

export const PaymentCardOption = connectScopedPaymentCardOption(PaymentCardOptionPure);
